/* eslint-disable angular/document-service */
import React from 'react';
import PropTypes from 'prop-types';
import { assetUrl } from '../../config/asset-config';

export default function DefaultState({ header, text }) {
    const iconStyle = {
        width: '91px',
        height: '102px',
    };

    return (
        <div className="font-gray-40">
            <img style={iconStyle} src={assetUrl('assets/img/tv-uni-icon.svg')} alt="ThankView Logo for default state"></img>
            <h1 className="font-size-24px margin-b-0px">{ header }</h1>
            <p className="font-size-16px margin-t-4px margin-auto max-width-400px">{ text }</p>
        </div>
    );
}

DefaultState.propTypes = {
    header: PropTypes.string,
    text: PropTypes.string,
};
